import tippy from 'tippy.js';
import { genderIcon }  from '~/assets/icons/js/genderIcon';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    /* Commands Gender */
    COMMANDS.add('exchange-shape-gender',{
        run:function (editor,sender,params){
            const view = params.view;
            const model = view.model;
            const current_component = model.components().models[1];
            const type = current_component.attributes.type;
            if(type == 'C-GENDER-RADIO'){
                current_component.replaceWith(
                    {
                        type:'C-GENDER-SELECT',
                    }
                )
            }else{
                current_component.replaceWith(
                    {
                        type:'C-GENDER-RADIO',
                    }
                )
            }
            
            
        }

    })

    /* Model Gender */
    var model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'C-GENDER',
            droppable: false, 
            classes:['form-group'],
            style:{
                padding:"0.5em",
                display:'block'
            },
            components:[
              {
                type:'text',
                content:'Gender'
              },
              {
                type:'C-GENDER-SELECT',
              }
            ],
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-GENDER")
                return { type:'C-GENDER' }
        }
    });

    /* View gender */
    var view = VIEW.extend({
        onRender() {
            this.createCustomMenu();
        },

        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
        createCustomMenu: function(){
            let el = this.el;
            var self = this;
            let tooltip = /*html*/
            `
            <style>
                
                .list-toggle{
                    display: flex;
                    list-style: none;
                    padding: 0;
                    margin:0;
                }
                .list-toggle .item{
                    margin: 0 0.3rem;
                    padding: 0 0.5rem;
                }
                .dropdown-menu{
                    background: transparent;
                    border: none;
                    min-width: 14rem;
                    display:flex;
                }
            </style>
            <div id="template">
                <ul class="list-toggle">
                    <li class="item exchange">
                        <i class="fas fa-sync"></i>
                    </li>
                </ul>
            </div>
            `
            
            const instance = tippy(el, {
                content: tooltip,
                allowHTML: true,
                trigger: 'click',
                theme: 'light',
                interactive: true,
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    /* e.preventDefault(); */
                    let item_exchange = instance.popper.querySelector('.item.exchange');
                    item_exchange.addEventListener('click',(e) =>{
                        e.preventDefault();
                        editor.runCommand('exchange-shape-gender', {view: self });
                        instance.hide();
                    });
                },
            });
            
            
        },

    });

    DOMC.addType('C-GENDER',{
        model: model,
        view: view
    });

    BM.add('B-GENDER', {
        label:"GENDER",
        content: { 
          type: 'C-GENDER',
         },
         category:"ADVANCE COMPONENT",
        media: genderIcon,
    });
    
  };
  